export default "__VITE_ASSET__VSWck3bq__"